import { Component, signal, ViewChild } from '@angular/core';
import { NotificationService } from '../../../../../../libs/utils/ng-shared-components/src';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { IssueDto } from '../../../api/dtos/IssueDto';
import { IssueResolutionListDto } from '../../../api/dtos/IssueResolutionListDto';
import { ApiAdminIssue } from '../../../api/endpoints/ApiAdminIssue';
import { IssueGridComponent } from './issue-grid.component';

@Component({
  standalone: false,
  selector: 'mf-issue-grid-page',
  templateUrl: './issue-grid-page.component.html',
  styleUrls: ['./issue-grid-page.component.scss'],
})
export class IssueGridPageComponent {
  constructor(
    private _modalService: ModalService,
    private _apiAdminIssue: ApiAdminIssue,
    private _notificationService: NotificationService
  ) {}

  @ViewChild('grid')
  grid: IssueGridComponent;

  selectedItems = signal<IssueDto[]>([]);

  onSelectedItems(issues: IssueDto[]) {
    this.selectedItems.set(issues);
  }

  resolve() {
    this._modalService.openYesOrNoModal({
      openData: {
        title: 'Confirmar resolución',
        message: '¿Estás seguro de que quieres marcar los incidentes seleccionados como resueltos?',
      },
      onCloseSuccess: async () => {
        const dto = new IssueResolutionListDto();
        dto.entityIdList = this.selectedItems().map((i) => i.id);
        this._apiAdminIssue.bulkResolve(dto);
        this._notificationService.showSuccess('Incidentes marcados como resueltos.');
        this.grid.refreshGrid();
      },
    });
  }
}
